<template>
    <div>
        <div class="index-top flex flex-center-cz">
            <div class="font-xxl font-bold" style="margin-left: 200px;margin-right: 150px;">量子文档</div>
            <div class="font-m margin-left-xl margin-right-xl pointer index-nav " :class="{'font-bold':activeMenu=='home'}" @click="home" >首页</div>
            <div class="font-m margin-left-xl margin-right-xl pointer index-nav" :class="{'font-bold':activeMenu=='down'}" @click="down">小程序</div>
            <div v-if="false" class="font-m margin-left-xl margin-right-xl pointer index-nav" :class="{'font-bold':activeMenu=='member'}" @click="member">升级会员</div>
            <div class="font-m margin-left-xl margin-right-xl pointer index-nav" :class="{'font-bold':activeMenu=='help'}" @click="help">帮助中心</div>
            <div class="font-m margin-left-xl margin-right-xl pointer index-nav" :class="{'font-bold':activeMenu=='log'}" @click="log">更新日志</div>
            <div class="font-m margin-left-xl margin-right-xxl pointer index-nav" :class="{'font-bold':activeMenu=='about'}" @click="about" >关于我们</div>
            <div class="font-m margin-left-xl margin-right-xxl pointer index-nav" :class="{'font-bold':activeMenu=='contact'}" @click="contact" >联系我们</div>
            <div class="font-m margin-left-xxl  btn-blue-line w120 pointer " @click="person" >前往个人空间</div>
        </div>
        <router-view></router-view>  
        <div class="index-bottom padding-xl flex flex-space-between">
            <div class="flex" style="margin-left: 100px;">
                <div class="index-bottom-menu flex flex-col">
                    <div class="font-xl color-white pointer">产品</div>
                    <div class="font-m margin-top-l color-white pointer" @click="home">首页</div>
                    <div class="font-m margin-top-m color-white pointer" @click="down">小程序</div>
                    <!-- <div class="font-m margin-top-m color-white pointer">升级会员</div> -->
                </div>
                <div class="index-bottom-menu flex flex-col">
                    <div class="font-xl color-white pointer">服务</div>
                    <div class="font-m margin-top-l color-white pointer" @click="help">帮助中心</div>
                    <div class="font-m margin-top-m color-white pointer" @click="secret">隐私协议</div>
                    <div class="font-m margin-top-m color-white pointer" @click="agreement">使用协议</div>
                </div>
                <div class="index-bottom-menu flex flex-col">
                    <div class="font-xl color-white pointer">公司</div>
                    <div class="font-m margin-top-l color-white pointer" @click="about">关于我们</div>
                    <div class="font-m margin-top-m color-white pointer" @click="contact">联系我们</div>
                </div>
            </div>
            <div class="flex flex-col flex-center-cz" style="margin-right: 80px;">
                <div class="font-m color-white" style="margin-top: 15px;">关注量子文档公众号</div>
                <img class="margin-top-xl" style="width: 120px;height: 120px;" src="@/assets/images/qrcode.png"/>
            </div>
        </div>
        <div class="index-sign flex flex-center-sp"><span>Copyright @ 2022 安宇润德 </span><span class="margin-left-m pointer"><a href="https://beian.miit.gov.cn ">京ICP备11029966号-7</a></span></div>

    </div>

</template>

<script>


 export default {
    name: "Index",
    data() {
        return {
            activeMenu :'home'

        }
    },
    methods: {
        home() {
            this.activeMenu = "home";
            this.$router.push({
              path: '/',
          }) 

        },
        person() {
            this.activeMenu = "person";
            this.$router.push({
              path: '/person',
          }) 
        },
        down() {
            this.activeMenu = "down";
            this.$router.push({
              path: '/down',
          }) 
        },
        secret() {
            this.activeMenu = "home";
            this.$router.push({
              path: '/secret',
          }) 
        },
        agreement() {
            this.activeMenu = "home";
            this.$router.push({
              path: '/agreement',
          }) 
        },
        member() {
            this.activeMenu = "member";
            this.$router.push({
              path: '/beMember',
          }) 
        },
        log() {
            this.activeMenu = "log";
            this.$router.push({
              path: '/updateLog',
          }) 
        },
        help() {
            this.activeMenu = "help";
            this.$router.push({
              path: '/help',
          }) 
        },
        contact() {
            this.activeMenu = "contact";
            this.$router.push({
                path: '/contact',
            })
        },
        about() {
            this.activeMenu = "about";
            this.$router.push({
                path: '/about',
            })
        }
    }
}
    
</script>

<style scoped>

.index-top {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    top:0px;
    width: 100%;
    position: fixed;
    height: 60px;
    text-align: left;
    z-index: 999;
    border-bottom: 1px solid rgba(0, 0, 0, .1);

}

.index-nav:hover {
    font-weight: 600;
}


.index-bottom {
    margin-top: 50px;
    background-color: #4f4f4f;
}

.index-bottom-menu {
    margin-top: 15px;
    width: 200px;
}

.index-sign {
    width: 100%;
    height: 60px;
    color: #f2f8ff;
    background-color: #4f4f4f;
}

a {
  color: #f2f8ff; /* 设置为黑色 */
  text-decoration: none; /* 去掉下划线 */
}

</style>


// WEBPACK FOOTER //
// src/views/Index.vue